import '../BiometricClient/BiometricClient.module.css'
import React, {useEffect, useRef, useState} from "react";
import styles from "../BiometricClient/BiometricClient.module.css";
import PhotoItem from "../BiometricClient/PhotoItem/PhotoItem";
import noImage from "../../../Img/Biometric/shot.svg";
import InputItemLight, {IRefInputItemLight} from "../../../FormTemplate/InputItemLight/InputItemLight";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../../WaitLoader/WaitLoader";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import useApiQueryBundle from "../../../ApiQuery/UseApiQueryBundle";
import TableItem from "../../../FormTemplate/TableItem/TableItem";
import {useSelector} from "react-redux";
import {ReduxStateInt} from "../../../Reducer/GlobalReducer";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import {createSecurePair} from "tls";
import imageCompression from 'browser-image-compression';
import {rejects} from "assert";
interface ITabItem
{
    id:number
    name:string
    logo?:string
    active:boolean
}
interface ISimItem
{
    ctn:string
    imei:string
}
interface ISimUnit
{
    ctn:string
    activated:boolean
}

interface IAllowSendBundle
{
    isFace:boolean
    isDoc:boolean
    isSim:boolean
}


export default function BiometricWorker()
{
    const refState = useRef<ErrorLineItemRef>(null)

    const authUser = useSelector((state: ReduxStateInt) => {
        return state.authLogin
    })

    const [imgFace, setImgFace] = useState(noImage)
    const [imgDoc, setImgDoc] = useState(noImage)
    const [imgCardOne, setImgCardOne] = useState(noImage)
    const [imgCardTwo, setImgCardTwo] = useState(noImage)

    const [simData, setSimData] = useState<string>("")
    const [simImei, setSimImei] = useState<string>("000000000000000")


    const [simList, setSimList] = useState<ISimItem[]>([])

    const refSim = useRef<IRefInputItemLight>(null)
    const refImei = useRef<IRefInputItemLight>(null)

    const dataSimList = useRef<any>()
    //const [ldrClientUpdate,rsClientUpdate,exClientUpdate] = useApiQuery("/biometric/client/update","post",dataClientUpdate);
    const [ldrSimList, exSimList] = useApiQueryBundle.useApiQueryPost("/biometric/worker/sim/list",dataSimList)
    const [simUnitList,setSimUnitList] = useState<ISimUnit[]>([])

    const [dgSend, setDgSend] = useState(false)

    const data = useRef(new FormData())
    //const [ldrUploadItem,rsUploadItem,exUploadItem] = useApiQuery("/biometric/item/upload","file",data);
    const [ldrUploadItem,exUploadItem] = useApiQueryBundle.useApiQueryFile("/biometric/worker/upload",data, true);

    const [sendMode, setSendMode] = useState(0)


    const [allowSend, setAllowSend] = useState(false)
    const [allowSendBundle, setAllowSendBundle] = useState<IAllowSendBundle>({
        isDoc: false,
        isFace: false,
        isSim: false
    })


    const [crTab,setCrTab] = useState(0)
    const [tabList, setTabList] = useState<ITabItem[]>([
        {
            id:0,
            name:"Сэлфи",
            active: true,
        },
        {
            id:1,
            name:"Док",
            active: true,
        },
        {
            id:2,
            name:"Миг.карта",
            active: true,
        },
        {
            id:3,
            name:"Сим",
            active: true
        },
    ])

    useEffect(()=>{
        validateSend()
    },[allowSendBundle])


    useEffect(()=>{
        console.log("sendMode ->", sendMode)
    },[sendMode])




    useEffect(()=>{
        loadSimList()
    },[dataSimList])



    const validateSend = () =>{
        const val = Object.values(allowSendBundle)

        const x = val?.filter((item)=> typeof item === "boolean" && !item)
        if(x?.length) setAllowSend(false)
        else setAllowSend(true)

    }


    async function resizeImage(base64: string){
        return new Promise<string>((resolve) => {
            const image = document.createElement('img');

            image.src = base64;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if( ctx === null)
                {
                    resolve("")
                    return
                }

                const step = 0.86;

                canvas.width = image.width * step;
                canvas.height = image.height * step;
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                resolve(canvas.toDataURL());
            };
        });
    }

    const  getBase64Size = (base64: string): number => {
        return Math.ceil(base64.length * 0.73);
    }


    async function normImgSize(base64:string, size:number):Promise<string>{
        let i = 0
        while (getBase64Size(base64) > size && i < 10) {
            if(! base64) break
            base64 = await resizeImage(base64)
            i++
        }
        return base64
    }


    async  function handleUpload() {
        const maxFileSize = 1024 * 1024 * 2
        data.current.delete('face')
        data.current.delete('doc')
        data.current.delete('cardOne')
        data.current.delete('cardTwo')
        data.current.delete('data')

        data.current.append('data', JSON.stringify({sim:simList, user:authUser ? authUser : "somebody"}))

        setDgSend(true)
        setSendMode(1)



        const blobFace = new Blob([imgFace], {type : 'text/plain'})

        data.current.append('face', blobFace ,"base64.png");

        //console.log("face", imgFace)


//        const blobDoc = new Blob([imgDoc], {type : 'text/plain'})
        const blobDoc = new Blob([await normImgSize(imgDoc, 3 * 1024 * 1024)], {type : 'text/plain'})



        data.current.append('doc', blobDoc ,"base64.png");

        if(imgCardOne !== noImage){
            const blobCardOne = new Blob([await normImgSize(imgCardOne, 2 * 1024 * 1024)], {type : 'text/plain'})
            data.current.append('cardOne', blobCardOne ,"base64.png");
        }
        if(imgCardTwo  !== noImage){
            const blobCardTwo = new Blob([await normImgSize(imgCardTwo, 2 * 1024 * 1024)], {type : 'text/plain'})
            data.current.append('cardTwo', blobCardTwo ,"base64.png");

        }

        exUploadItem().then((e)=>{
            loadSimList()
            if(e?.success)
            {
                setSimList([])
                setImgFace(noImage)
                setImgDoc(noImage)
                setImgCardOne(noImage)
                setImgCardTwo(noImage)
                setSendMode(0)
                setAllowSendBundle({...allowSendBundle,isSim: false})
                setTimeout(()=>{
                    console.log("off")
                    setDgSend(false)
                }, 3000)
                return
            }
            setDgSend(false)
            //setSendMode(0)
        })



    }

    const loadSimList = ()=>{
        exSimList().then((e)=>{
            if(e?.success)
            {
                setSimUnitList(e?.payload)
                return
            }
        })

    }

    const buildTabList = ()=>{
        const x = tabList?.map((item,idx)=>{
            if(!item?.active) return null
            return (
                <div className={[styles.tabItem, item?.id===crTab ? styles.actTabItem : ""].join(' ')} key={idx}
                     onClick={()=>setCrTab(item?.id)}
                >
                    {item?.name}
                </div>
            )
        })
        return(
            <div className={styles.tabRowCont}>
                {x}
            </div>
        )

    }


    const buildFaceCont = ()=>{
        return(
            <div className={styles.fcCont}>

                <div className={styles.fcImgFrame}>
                    <PhotoItem
                        onPhoto={(e)=>{
                            if(!e) return
                            setImgFace(e)
                            setAllowSendBundle({...allowSendBundle,isFace: e!==noImage})

                        }}
                        img={imgFace}
                        canPhoto={true}
                        load={false }
                        frameType={0}
                        imgHeight={350}
                        title={"Сэлфи"}
                        needUpdate={false}
                    />
                </div>
            </div>
        )
    }
    const buildDocCont = ()=>{
        return(
            <div className={styles.fcCont}>
                <div className={styles.docCont}>
                    <div className={styles.docImgCont}>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{
                                    if(! e) return
                                    setImgDoc(e)
                                    setAllowSendBundle({...allowSendBundle,isDoc: e!==noImage})
                                }}
                                img={imgDoc}
                                canPhoto={true}
                                load={false }
                                frameType={1}
                                imgHeight={350}
                                title={"Документ"}
                                needUpdate={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const buildCardCont = ()=>{
        return(
            <div className={styles.fcCont}>
                <div className={styles.docCont}>
                    <div className={styles.docImgCont}>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{setImgCardOne(e)}}
                                img={imgCardOne}
                                canPhoto={true}
                                load={false }
                                frameType={1}
                                imgHeight={350}
                                title={"Мигр. карта сторона 1"}
                                needUpdate={false}
                            />
                        </div>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{setImgCardTwo(e)}}
                                img={imgCardTwo}
                                canPhoto={true}
                                load={false }
                                frameType={1}
                                imgHeight={350}
                                title={"Мигр. карта сторона 2"}
                                needUpdate={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    const handleSimRemove = (sim:ISimItem)=>{
        const x = simList?.filter((item)=>item?.ctn !== sim?.ctn)
        setSimList(x)
    }

    const buildSimList = ()=>{
        const x = simList?.map((item,idx)=>{
            return(
                <div key={idx} className={styles.simContXW}>
                    <div className={styles.simBlock}>
                        <div className={[styles.smCtn].join(' ')}>{item?.ctn ? item?.ctn : "-"}
                        </div>
                        <div className={styles.smImei}>
                            i:{item?.imei ? item?.imei : "-"}
                        </div>

                    </div>

                    <div className={styles.simOpCont}>
                        <div className={styles.smBIconCont}>
                            <i className='bx bx-message-alt-x'
                               onClick={()=>handleSimRemove(item)}
                            ></i>

                        </div>
                    </div>

                </div>
            )
        })
        return(
            <div className={styles.smBlockCont}>
                {x}

            </div>
        )
    }


    const handleAddSim = ()=>{
        const z = simList?.filter((item)=>item?.ctn === simData)
        if(z?.length)
        {
            if(refState.current)refState.current.show(`Номер ${simData} уже внесен`, true, 2000)
            return
        }

        if(! refSim.current || !refState.current ||  !refImei.current) return
        if(simList?.length>=3)
        {
            refState.current.show("Достигнуто максимальное количество номеров", true, 3000)
            return

        }

        if(!refSim.current.validate() || simData?.length < 10 || !simData?.match(/^9[0-9]{9}$/ui))
        {
            refState.current.show("Номер не корректен", true, 3000)
            return
        }
        if(!refImei.current.validate())
        {
            refState.current.show("IMEI не корректен", true, 3000)
            return

        }



        const x:ISimItem ={
            ctn: simData,
            imei: simImei
        }


        setSimList([...simList,x])
        setAllowSendBundle({...allowSendBundle,isSim: true})
        setSimData("")
    }

    const buildSend = (_sendMode:number)=>{
        if(_sendMode === 0)
            return(
                <ModalWindow >
                    <div className={styles.rsCont}>
                        Задание отправлено
                    </div>
                </ModalWindow>
            )
        if(_sendMode === 1)
            return(
                <ModalWindow >
                    <div className={styles.rsCont}>
                        <WaitLoader loading={true} onlyLoading={true}>

                        </WaitLoader>
                        <div className={styles.rsText}>Идет отправка</div>
                    </div>
                </ModalWindow>
            )
        return null
    }


    const buildSimCont = ()=>{
        return(
            <div className={styles.simCont}>

                <div className={"row w-100"}>
                    <div className={"d-flex col-md-12 justify-content-center my-2 flex-column"}>
                        <div>Количество {simList?.length}</div>
                        {buildSimList()}
                    </div>

                </div>
                <div className={"row w-100 my-1"}>

                    <div className={"d-flex col-md-6 justify-content-center my-1"}>
                        <InputItemLight
                            mode={"e"}
                            title={"СИМ Карта"}
                            placeHolder={"XXXXXXXXXX"}
                            val={simData}
                            regExp={/^[0-9]{10}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                let k = e
                                const rg = e?.match(/^((\+7)|(8)|(7)|(^))9[0-9]{9}$/ui)
                                if(rg) k = rg[0]?.slice(-10)
                                setSimData(k)
                            }}
                            minWidth={"100%"}
                            //onlySpace={false}
                            titleColNumber={4}
                            maxLen={12}
                            trim={true}
                            canEmpty={false}
                            ref={refSim}
                            info={"Номер или icc сим карты"}
                        />
                    </div>
                    <div className={"d-flex col-md-6 justify-content-center my-1"}>
                        <InputItemLight
                            mode={"e"}
                            title={"IMEI"}
                            minWidth={"100%"}
                            placeHolder={"XXXXXXXXXXXXXXXXXXXXXXXX"}
                            val={simImei}

                            regExp={/^[0-9]{14,16}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                setSimImei(e)
                            }}
                            //onlySpace={false}
                            titleColNumber={4}
                            maxLen={16}
                            trim={true}
                            canEmpty={false}
                            ref={refImei}
                            info={"imei телефона"}
                        />
                    </div>

                </div>


                <ButtonContainer my={10} resize={true}>
                    <button type="button" className="btn btn-face "
                            onClick={handleAddSim}
                    >Добавить сим</button>

                </ButtonContainer>
            </div>
        )
    }

    const buildWorkItem = ()=>{
        return (
            <div className={styles.workItem}>
                <div>
                    <ErrorLineItem ref={refState}/>
                </div>
                <WaitLoader loading={ldrSimList } onlyLoading={true}>

                </WaitLoader>
            </div>
        )
    }

    return(
        <div className={styles.mainCont}>
            {dgSend  && buildSend(sendMode)}
            <div className={styles.tabCont}>
                {buildTabList()}
                <div className={styles.tabContent}>
                    {buildWorkItem()}
                    {crTab === 0 && buildFaceCont()}
                    {crTab === 1 && buildDocCont()}
                    {crTab === 2 && buildCardCont()}
                    {crTab === 3 && buildSimCont()}

                </div>
            </div>

            <div className={styles.btnBlock}>
                <ButtonContainer my={5} resize={true}>
                    <button type="button" className={["btn btn-face ", styles.sendButton].join(' ')}
                            onClick={handleUpload}
                            disabled={!allowSend || dgSend}
                    >Отправить</button>
                </ButtonContainer>
                <ButtonContainer my={5} resize={true}>
                    <button type="button" className={["btn btn-face "].join(' ')}
                            onClick={loadSimList}
                    >Обновить</button>
                </ButtonContainer>

            </div>

            <TableItem
                data={simUnitList}
                column={[
                    {
                        title:"ФИО",
                        mode:"f",
                        type: 0,
                        maxLen: 30,
                        fieldId:"clientFio"
                    },
                    {
                        title:"Номер",
                        mode:"f",
                        type: 0,
                        maxLen: 12,
                        fieldId:"ctn"
                    },
                    {
                        title:"Активирован",
                        mode:"s",
                        type: 5,
                        maxLen: 12,
                        fieldId:"activated"
                    },
                ]}
                onPageCount={10}
                onReload={loadSimList}
            />


        </div>
    )
}